import { NavLink, useParams } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import { useOrganizationPolicies } from "../hooks/useOrganizationPolicies";

interface Props {}

const OrganizationSettingsMenu = (props: Props) => {
  const { orgName } = useParams<{ orgName: string }>();
  const {
    authorizedToManageOrgRoles,
    authorizedToManageDocumentTypes,
    authorizedToManageAdminRoles,
    authorizedToManagePermitTypes,
  } = useOrganizationPolicies();

  return (
    <Menu pointing secondary color="green">
      {authorizedToManagePermitTypes && (
        <Menu.Item as={NavLink} content="Permit Types" to={"/" + orgName + "/settings/permit-types"} />
      )}
      {authorizedToManageDocumentTypes && (
        <Menu.Item as={NavLink} content="Permit Document Types" to={"/" + orgName + "/settings/document-types"} />
      )}
      {authorizedToManageOrgRoles && <Menu.Item as={NavLink} content="Roles" to={"/" + orgName + "/settings/roles"} />}
      {authorizedToManageAdminRoles && (
        <Menu.Item as={NavLink} content="Admin Roles" to={"/" + orgName + "/settings/admin-roles"} />
      )}
    </Menu>
  );
};

export default OrganizationSettingsMenu;
